import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'gatsby-plugin-intl';
import Layout from '../../components/layout';
import ImgVistaExplodida from '../../images/vista-explodida.png';
import ImgVistaExplodida2 from '../../images/vista-explodida-2.png';
import ImgVistaExplodida3 from '../../images/vista-explodida-3.png';
import ImgVistaExplodida4Pt from '../../images/vista-explodida-4-pt.png';
import ImgVistaExplodida4En from '../../images/vista-explodida-4-en.png';
import ImgVistaExplodida4Es from '../../images/vista-explodida-4-es.png';
import ImgIconeCirculo from '../../images/icone-circulo.png';
import './style.scss'

export default ({ location }) => {
  const intl = useIntl();

  const { locale } = intl;

  const obtemImagemVistaExplodida4 = () => {
    if (locale === 'pt') return ImgVistaExplodida4Pt;
    if (locale === 'en') return ImgVistaExplodida4En;
    return ImgVistaExplodida4Es;
  };

  return (
    <Layout location={location}>
      <Helmet bodyAttributes={{ class: 'page-desenhos-e-ilustracoes-tecnicas page-template page-template-page-expresso page-template-page-expresso-php page full-width custom-font-enabled single-author mob-menu-slideout' }}>
        <title>{intl.formatMessage({ id: 'Desenhos e Ilustrações Técnicas | Ideia 2001' })}</title>
      </Helmet>

      <div id="primary" className="site-content">
        <div className="tituloProduto mt-5">
          <div className="container">
            <div className="row">
              <div className="col-md-12 pt-3 pb-3 contatoTitulo">
                <h1 className="tt-u m-0">
                  {intl.formatMessage({ id: 'Ilustrações e Desenhos Técnicos' })}
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="container-topo">
          <div className="container mt-5 mb-5 container-cima">
            <div className="row">
              <div className="col-md-6 produtosInterno">
                <h2 className="tituloProdutoInterno">{intl.formatMessage({ id: 'O que é?' })}</h2>

                <p>{intl.formatMessage({ id: 'É um serviço de criação de Ilustrações e Desenhos Técnicos como:' })}</p>
                <div className="container-icone-texto">
                  <img
                    className="icone-circulo"
                    src={ImgIconeCirculo}
                    alt={intl.formatMessage({ id: 'Ícone circulo' })}
                  />

                  <p>{intl.formatMessage({ id: 'Figuras de Peças e Vistas Explodidas de Conjuntos.' })}</p>
                </div>
                <div className="container-icone-texto">
                  <img
                    className="icone-circulo"
                    src={ImgIconeCirculo}
                    alt={intl.formatMessage({ id: 'Ícone circulo' })}
                  />

                  <p>{intl.formatMessage({ id: 'Folhetos e Manuais Técnicos.' })}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="container-laranja">
            <div className="container mt-5 mb-5">
              <div className="row">
                <div className="col-md-6 produtosInterno">
                  <p className="titulo-container">
                    {intl.formatMessage({ id: 'Ilustrações e Desenhos Técnicos' })}
                  </p>

                  <p>
                    {intl.formatMessage({ id: 'Criação de ilustrações isométricas de peças e conjuntos para incorporação ao catálogo, a manuais técnicos, etc.' })}
                    <br />
                    {intl.formatMessage({ id: 'Este serviço é uma facilidade oferecida pela Ideia 2001 para obtenção/criação de imagens bem definidas e detalhadas.' })}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="container mt-5 mb-5 container-imagem-fundo-branco">
            <img src={ImgVistaExplodida} alt={intl.formatMessage({ id: 'Imagem vista explodida' })} />
          </div>
        </div>

        <div className="container-formatos-tipo-de-ilustracao">
          <div className="container mt-5 mb-5">
            <div className="row mt-5">
              <div className="col-md-6 text-center container-content">
                <p className="titulo-container">
                  {intl.formatMessage({ id: 'Formato das imagens' })}
                </p>

                <p>
                  {intl.formatMessage({ id: 'As imagens são fornecidas no formato SVG que permite sua ampliação sem alterar a definição do traçado. Essa característica possibilita imagens bitmaps em alta resolução, que se adaptam ao tamanho da tela e favorecem a utilização da função zoom.' })}
                </p>

                <img src={ImgVistaExplodida2} alt={intl.formatMessage({ id: 'Imagem vista explodida 2' })} />
              </div>

              <div className="col-md-6 text-center container-content">
                <p className="titulo-container">
                  {intl.formatMessage({ id: 'Tipos de ilustração' })}
                </p>

                <p>
                  {intl.formatMessage({ id: 'As imagens podem ser elaboradas em ‘line-art’ (contorno), sombreadas ou realísticas.' })}
                </p>

                <img src={ImgVistaExplodida3} alt={intl.formatMessage({ id: 'Imagem vista explodida 3' })} />
              </div>
            </div>
          </div>
        </div>

        <div className="container-confecoes-de-manuais">
          <div className="container mt-5 mb-5">
            <div className="row mt-5">
              <div className="col text-center container-content">
                <p className="titulo-container">
                  {intl.formatMessage({ id: 'Confecção de Folhetos e Manuais Técnicos' })}
                </p>

                <div className="container-imagem-vista-explodida">
                  <div className="content-imagem-vista-explodida">
                    <img
                      src={obtemImagemVistaExplodida4()}
                      alt={intl.formatMessage({ id: 'Imagem vista explodida 4' })}
                    />
                  </div>
                </div>

                <p className="texto-container">
                  {intl.formatMessage({ id: 'Mais um serviço oferecido pela Ideia 2001 para empresas que necessitam incorporar folhetos com instruções detalhadas aos seus produtos.' })}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container-cinza">
          <div className="tituloLaranja mt-5">
            <div className="container">
              <div className="text-center">
                <p className="texto-maior">{intl.formatMessage({ id: 'Formatos' })}</p>

                <p className="texto-menor">{intl.formatMessage({ id: 'Os Folhetos e Manuais Técnicos são fornecidos no formato PDF prontos para impressão em gráficas ou para download pela internet. Formato físico e dimensões de acordo com as especificações definidas por sua empresa.' })}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
